"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgCropped = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var div_cropped_1 = require("./div-cropped");
var Img = styled_components_1.default.img(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: block;\n  /* object-fit: contain; */\n"], ["\n  width: 100%;\n  height: 100%;\n  display: block;\n  /* object-fit: contain; */\n"])));
exports.ImgCropped = (0, react_1.memo)(function (_a) {
    var src = _a.src, cropRectRelative = _a.cropRectRelative;
    return (react_1.default.createElement(div_cropped_1.DivCropped, { component: react_1.default.createElement(Img, { src: src }), cropRectRelative: cropRectRelative }));
});
exports.ImgCropped.displayName = 'ImgCropped';
var templateObject_1;
